export default {
    'proforma-invoices': 'Facturas proforma',
    'the-proforma-invoice': 'Es la factura proforma?',
    'add-a-proforma-invoice': 'Agregar factura proforma',
    'proforma-invoice': 'Factura proforma',
}